import React from "react";
import StatusIcon from "../../../../shared/components/generic/status-icon/status-icon";
import { getStatusLabel } from "../../utils/assessment-view-utils";

const AssessmentBooleanCell = ({ value }) => {
	if (value === null || value === undefined) {
		return <StatusIcon status="empty" />;
	}

	if (typeof value !== "boolean") {
		return <>{value}</>;
	}

	return (
		<StatusIcon
			status={value ? "success" : "danger"}
			label={getStatusLabel(value)}
		/>
	);
};

export default AssessmentBooleanCell;